import React from 'react';
import ReactDOM from 'react-dom';
import SwitchableOdds from './SwitchableOdds';
import { SpectateStoreProvider } from '~SpectateStore/SpectateStoreProvider';

export const renderSwitchableOdds = (props, el) => {
    ReactDOM.render(
        <SpectateStoreProvider>
            <SwitchableOdds { ...props }/>
        </SpectateStoreProvider>,
        el
    );

    return () => {
        ReactDOM.unmountComponentAtNode(el);
    };
};
